import PaymentMethod from './PaymentMethod';
import { PaymentMethodProps, PaymentMethodValueProps } from './types';

export type { PaymentMethodProps, PaymentMethodValueProps };
export default PaymentMethod;
